import { useTranslation } from "react-i18next";
import classNames from "classnames";
import type { ButtonProps } from "@mui/material";
import { AppButton } from "../../../../../shared/components/AppButton";
import { SparksIcon } from "../../../../../shared/icons/SparksIcon";
import { TButton } from "../../../../types/buttons";
import styles from "../styles.module.css";
import { AppIconButton } from "../../../../../shared/components/AppIconButton";

interface Props extends ButtonProps {
  btnType: TButton;
  className?: string;
}

export const AskGPTButton = ({ btnType, className, ...props }: Props) => {
  const { t } = useTranslation();
  const cls = classNames(styles.button, styles["ask-gpt-button"], className);

  if (btnType === "icon_btn") {
    return (
      <AppIconButton className={cls} {...props}>
        <SparksIcon />
      </AppIconButton>
    );
  }

  return (
    <AppButton
      buttonType={"text"}
      icon={<SparksIcon />}
      className={cls}
      {...props}
    >
      {t("sidebar.ask_gpt_button")}
    </AppButton>
  );
};
